import { object, string, ref } from 'yup';
import { ChangePasswordFormType } from './types';
import { REGEXP_PASSWORD } from '../../../../utils/validations';
import i18n from '../../../../i18n';

export const ChangePasswordFormSchema = object<ChangePasswordFormType>({
  currentPassword: string().required(() =>
    i18n.t('validation:password.current')
  ),
  newPassword: string().matches(REGEXP_PASSWORD, () =>
    i18n.t('validation:password.format')
  ),
  repeatPassword: string()
    .matches(REGEXP_PASSWORD, () => i18n.t('validation:password.format'))
    .oneOf([ref('newPassword')], () => i18n.t('validation:password.match')),
});
